import { selectRouterPathname } from '@noths/polaris-client-next-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { TaxonomyEntry } from 'src/redux/content/types';
import { selectTaxonomyContentEntry } from 'src/utils/selectTaxonomyContentEntry';

export const selectMatchedTaxonomyEntry = (state: ReduxApplicationState): TaxonomyEntry | null =>
  selectTaxonomyContentEntry(selectRouterPathname(state), state.content.entries ?? []);
